import { Box, Button, Typography, Stack, Tab, Tabs, Paper } from "@mui/material";
import React , { useState }from "react";
import CollectionProducts from "../../../../../components/CollectionDonationCard/CollectionProducts";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined"
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const DetailsNotification = ({ component, donation, t, collection , all , entityDonation}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [isCopied, setIsCopied] = useState(false);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const copyToClipboard = async () => {
    try {
      const textToCopy = `${new Date(donation?.donation?.createdDate).getFullYear()}${donation?.donation?.id}`;
      await navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
  };
  let currentTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (
    <Box sx={{ marginTop: "30px" }}>
      <Tabs value={selectedTab} onChange={handleTabChange} 
       centered={false}  // Set centered to false
       sx={{ justifyContent: 'flex-start' }} 
       >
        <Tab label="Detalhes" />
        <Tab label="Artigos" />
      </Tabs>

      <TabPanel value={selectedTab} index={0}>
        {/* Content for Tab 1 */}
        <Stack direction="column" gap="6px" pb={4}>
          <Typography
            variant="h6"
            color={"text.secondary"}
            fontWeight={600}
          >
            {t("code")}
          </Typography>
          <Box sx={{display: "flex", alignItems:"center"}}>
          <Typography variant="body1" sx={{ textTransform: "uppercase" }}>
            {new Date(donation?.donation?.createdDate).getFullYear()}
            {donation?.donation?.id}
          </Typography>
          <Typography onClick={copyToClipboard} sx={{color: "#37B34A", marginLeft: "25px",fontSize: "13px" , cursor:"pointer"}}>
          <ContentCopyIcon sx={{fontSize:"13px", marginRight:"3px"}}/>
          {isCopied ? 'Copiado!' : 'Copiar'}
          </Typography>
          
          </Box>
          
          <Typography
            variant="h6"
            color={"text.secondary"}
            fontWeight={600}
            marginTop={2}
          >
            {"Doador"}
          </Typography>
          <Typography variant="body1" sx={{ textTransform: "uppercase" }}>
            {entityDonation?.entity?.entityName}
          </Typography>
          <Box sx={{ width: 1, display: "flex", alignItems: "center" , mt:2}}>
            <CalendarMonthOutlinedIcon />
            <Typography
              variant="body2"
              sx={{ ml: 2 }}
              textTransform={"capitalize"}
              
            >
              {t("in")}{" "}
              <span>
              {new Date(
              donation?.donation?.availableFromDate
            ).toLocaleString("pt-PT", {
              day: "numeric",
              month: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
              formatMatcher: "best fit",
              timeZone: currentTimeZone,
            })}
              </span>{" "}
              {t("until")}{" "}
              <span>
              {new Date(
              donation?.donation?.expiryDate
            ).toLocaleString("pt-PT", {
              day: "numeric",
              month: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
              formatMatcher: "best fit",
              timeZone: currentTimeZone,
            })}
              </span>
            </Typography>
          </Box>
          <Box sx={{ display: "flex" ,  mt:2}}>
            <LocationOnOutlinedIcon />
            <Stack direction={"column"} ml={2}>
              <Typography>{donation?.addresses[0]?.addressLine}</Typography>
              <Typography>{donation?.addresses[0]?.district}</Typography>
              <Typography>{donation?.addresses[0]?.county}</Typography>
              <Typography>{donation?.addresses[0]?.subDivision}</Typography>
              <Typography>{donation?.addresses[0]?.postalCode}</Typography>
              <Typography>{donation?.addresses[0]?.locality}</Typography>
              <Typography
                color="primary"
                sx={{ textDecoration: "underline" }}
              >
                {donation?.addresses[0]?.latitude},
                {donation?.addresses[0]?.longitude}
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </TabPanel>
      
      <TabPanel value={selectedTab} index={1}>
        {/* Content for Tab 2 */}
        <Stack direction="column" gap="6px" pb={4}>
        <CollectionProducts
          products={donation?.donationProducts}
          t={t}
          componentType={"agenda"}
        />
        </Stack>
      </TabPanel>
    </Box>
  );
};

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Paper
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      sx={{ overflowY: "auto",
      maxHeight: "450px",}}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Paper>
  );
};

export default DetailsNotification;